<template>
<div class="flex flex-col">
    <div class="flex self-end items-center">
     `<select-box placeholder="Без сортировки" class=""
                                is_place no_padding fontIsNormal
                                :listItems="options"

                                v-model="selected_filter"
                                :positionLeft="true"
                                >
    </select-box>`
    </div>

     <team-list v-if="selected_filter==1" :main_array="teams"  sorting_func="-play_count,-id" key="playcountList" sorting_param="play_count" />
     <team-list  v-else :main_array="teamsPush"  sorting_func="name,-id" sorting_param="name" key="nameList" />

</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import teamList from './team-list-mobile.vue';
import axios from 'axios';
import { debounce } from 'lodash';
import SelectBox from '@/views/partners/selectbox';

export default {
  name: 'data-base-mobile',
  components: { SelectBox, teamList },
  data() {
    return {
      teams: [],
      teamsPush: [],
      firstChange: true,
      selected_filter: '0',
      render: 'unchanged',
      options: {
        0: { name: 'По алфавиту' },
        1: { name: 'По сыгранным играм' },
      },
    };
  },
  computed: {

    ...mapState({
      storeTeamsCount: state => state.partnersDbParams.dbTeamsCount,
    }),

  },

};
</script>
<style scoped>
.heading-class {
    font-size: 14px;
    font-weight: bold;
    color: #979797;
    border-bottom: 1px solid #979797;
    padding-bottom: 2px;
    margin-bottom: 20px;
    margin-top: 20px;
}
</style>
